module.exports = __webpack_public_path__ + "static/media/coupons_icon.801b2230.svg";